<template>
    <div>
        <!-- Секогаш плаќа примачот, па курирот наплаќа откуп + поштарина при достава. -->
        <div class="notification is-warning is-light mb-2" :class="{'els-dim': loading}">
            <div class="columns is-mobile is-gapless has-text-centered">
                <div class="column">
                    <p class="heading">Откуп</p>
                    <p class="title is-5 mb-0">{{ money ? money.cod : "-" }}</p>
                </div>
                <div class="column">
                    <p class="heading">Поштарина</p>
                    <p class="title is-5 mb-0">{{ money ? money.shipping : "-" }}</p>
                </div>
                <div class="column">
                    <p class="heading">Наплата при достава</p>
                    <p class="title is-5 mb-0">{{ money ? money.collected_on_delivery : "-" }}</p>
                </div>
            </div>
        </div>

        <p class="help is-danger" v-if="error">{{ error }}</p>

        <table class="table is-fullwidth is-narrow is-size-7 mb-0" v-if="items.length">
            <thead>
            <tr>
                <th>Ставка</th>
                <th class="has-text-right">Вкупно</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item, index) in items" :key="index">
                <td>
                    {{ item.description }}
                    <br>
                    <span class="has-text-grey">{{ item.service_name }}</span>
                </td>
                <td class="has-text-right"><b>{{ item.price }}</b></td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    export default {
        name: "ElsMoney",
        props: {
            money: {type: Object, default: null},
            items: {type: Array, default: () => []},
            loading: Boolean,
            error: {type: String, default: null}
        }
    }
</script>

<style scoped>
    .els-dim {
        opacity: 0.55;
    }
</style>
